import { render, staticRenderFns } from "./slicesDetailQuery.vue?vue&type=template&id=a300ba3a&scoped=true&"
import script from "./slicesDetailQuery.vue?vue&type=script&lang=js&"
export * from "./slicesDetailQuery.vue?vue&type=script&lang=js&"
import style0 from "./slicesDetailQuery.vue?vue&type=style&index=0&id=a300ba3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a300ba3a",
  null
  
)

export default component.exports